module.exports = __webpack_public_path__ + "media/img/career_starter-ed80cda53d81e6351a4c4dfb60d27924.jpg";